import _DatabaseModel from "./_DatabaseModel";

const TEAMS_TAB_USERS = 171;

class Team extends _DatabaseModel {
  static model = "team";
  static showSize = 8;
  static editDialogComponent = "team-edit-dialog";
  static tableHeaders = [{ textKey: "form.label.name", value: "name" }];

  static show = {
    buttons: ["edit"],
    reloadingModels: ["team_user"],
  };

  static filter = {
    parts: {
      fields: ["name", "description", "time_filter"],
      extended_fields: [],
      time_filter: ["created_at", "updated_at"],
    },
  };

  static basicInfo(object) {
    return [
      {
        labelKey: "form.label.created_at",
        value: object.created_at,
        type: "date_time",
      },
      {
        labelKey: "form.label.owner",
        value: object.owner.person,
        type: "link",
        to: "persons",
      },
    ];
  }

  static submenuActions = [
    this.commonActions.openActivities,
    this.commonActions.delete,
  ];

  static tabs = [
    this.detailTab,
    {
      titleKey: "person.persons",
      permission: TEAMS_TAB_USERS,
      component: "UsersTab",
      disabled: this.defaultDisabledTab(),
    },
  ];
}

export default Team;
